import { c as _c } from "react/compiler-runtime";
import { PlaceholderConfig, PlaceholderContext } from '@spa/lib/react/context/PlaceholderContext';
import { ReactElement, useContext } from 'react';
import PlaceholderComponent from '../placeholder/placeholder.component';
export interface Props {
  readonly id: string;
  readonly error?: boolean;
}
function PlaceholderFromContextComponent(t0) {
  const $ = _c(7);
  const {
    id,
    error
  } = t0;
  const props = useContext(PlaceholderContext);
  let placeholder;
  if (props.content && !error) {
    const t1 = `${id}-placeholder`;
    let t2;
    if ($[0] !== props.content || $[1] !== t1) {
      t2 = <div id={t1} aria-hidden="true" inert={true}>{props.content}</div>;
      $[0] = props.content;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    placeholder = t2;
  } else {
    const t1 = `${id}-placeholder`;
    let t2;
    if ($[3] !== error || $[4] !== props || $[5] !== t1) {
      t2 = <PlaceholderComponent {...props} id={t1} error={error} />;
      $[3] = error;
      $[4] = props;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    placeholder = t2;
  }
  return placeholder;
}
export default PlaceholderFromContextComponent;